import React, { useState, useEffect } from "react";
import {
  auth,
  useFirebase,
} from "../../../components/firebase/FirebaseProvider";
import { useParams, useLocation, Redirect, useHistory } from "react-router-dom";

import AppLoading from "../../../components/appLoading";

function LoginToken() {
  const [loadingToken, setLoadingToken] = useState(false);
  const { loading, user } = useFirebase();
  const { loginToken } = useParams();
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    const userLogin = async () => {
      setLoadingToken(true);
      try {
        await auth
          .signInWithCustomToken(loginToken)
          .then((ress) => console.log(ress));
        setLoadingToken(false);
      } catch (e) {
        if (e.message) {
          history.push("/login");
        }
        console.log(e.message)
      }
    };
    userLogin();
  }, []);

  if (user) {
    const redirectTo =
      location.state && location.state.from && location.state.from.pathname
        ? location.state.from.pathname
        : "/";
    return <Redirect to={redirectTo} />;
  }

  if (loading || loadingToken) {
    return <AppLoading />;
  }
}

export default LoginToken;
